import type { ticketState } from "modules/ticket";
import type { ComponentProps } from "react";
import type { AnalyticsProvider } from "utility/ga/AnalyticsContext";

type Input = {
  eventId: string;
  maybeGoods: ticketState["eventGoods"][number] | undefined;
};
type Output = ComponentProps<typeof AnalyticsProvider>["item"] | undefined;
type GetAnalyticsProviderItem = (input: Input) => Output;

export const getAnalyticsProviderItem: GetAnalyticsProviderItem = (input) => {
  const { eventId, maybeGoods } = input;

  if (maybeGoods === undefined) return undefined;

  const { _id: id, name, price_jpy: price, subClassName } = maybeGoods;

  return {
    eventId,
    eventGoodsFirestoreId: id ?? "",
    itemName: name,
    price,
    itemVariant: subClassName ?? "",
  };
};
